const isAuthenticated = (state) => { return !!state.accessToken }

const user = (state) => { return state.user }

const getPlace = (state) => { return state.place }

const roles = (state) => { return state.roles }

const params = (state) => { return state.params }

const accessToken = (state) => { return state.accessToken }

export default {
    isAuthenticated,
    user,
    getPlace,
    roles,
    params,
    accessToken,
}